var pug = require("!../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (levels) {pug_html = pug_html + "\u003Cdiv class=\"alert-center\"\u003E\u003Col role=\"list\"\u003E";
// iterate levels
;(function(){
  var $$obj = levels;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var level = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli role=\"listitem\"\u003E\u003Cdiv" + (pug.attr("data-ref", 'level(' + level + ')', true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var level = $$obj[pug_index0];
pug_html = pug_html + "\u003Cli role=\"listitem\"\u003E\u003Cdiv" + (pug.attr("data-ref", 'level(' + level + ')', true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fol\u003E\u003C\u002Fdiv\u003E";}.call(this,"levels" in locals_for_with?locals_for_with.levels:typeof levels!=="undefined"?levels:undefined));;return pug_html;};
module.exports = template;